export function toHashColorHexString(colorHex: string | undefined): string | undefined {
  if (colorHex != null) {
    return `#${colorHex}`;
  } else {
    return undefined;
  }
}